import FormInput from 'src/components/form-input';
import FormSelect from 'src/components/form-select';
import FormSwitch from 'src/components/form-switch';

import { ELinkMdi, ELinkSpeed, ELinkDuplex, IEdgeExtraData } from '../types';

const linkSpeedOptions = [
  { label: '10 Mbps', value: ELinkSpeed.TEN_MBPS },
  { label: '100 Mbps', value: ELinkSpeed.HUNDRED_MBPS },
];

const linkDuplexOptions = [
  { label: 'Full', value: ELinkDuplex.FULL },
  { label: 'Half', value: ELinkDuplex.HALF },
];

const linkMdiOptions = [
  { label: 'Auto', value: ELinkMdi.AUTO },
  { label: 'MDI', value: ELinkMdi.MDI },
  { label: 'MDI-X', value: ELinkMdi.MDI_PLUS },
];

export function CustomEdgeEditLink({
  data,
  onChangeEdgeData,
}: {
  data: IEdgeExtraData;
  onChangeEdgeData: (data: Partial<IEdgeExtraData>) => void;
}) {
  const {
    enableLink = true,
    autoNegotiation = true,
    linkSpeed,
    linkDuplex,
    linkMdi,
  } = data || {};

  return (
    <div
      className="mt-2 grid grid-cols-12 gap-4"
      data-testid="dialog-custom-edge-edit-link-panel"
    >
      <div className="col-span-4">
        <span className="text-sm font-medium leading-6 text-gray-900">
          Link
        </span>
      </div>
      <div className="col-span-8">
        <FormSwitch
          data-testid="dialog-custom-edge-edit-link-enable-link-switch"
          checked={enableLink}
          onChange={() => onChangeEdgeData({ enableLink: !enableLink })}
        />
      </div>
      <div className="col-span-4">
        <span className="text-sm font-medium leading-6 text-gray-900">
          Auto Negotiation
        </span>
      </div>
      <div className="col-span-8">
        <FormSwitch
          data-testid="dialog-custom-edge-edit-link-auto-negotiation-switch"
          checked={autoNegotiation}
          onChange={() => {
            if (!autoNegotiation) {
              onChangeEdgeData({
                autoNegotiation: true,
                linkSpeed: ELinkSpeed.AUTO,
                linkDuplex: ELinkDuplex.AUTO,
              });
            } else {
              onChangeEdgeData({
                autoNegotiation: false,
                linkSpeed: ELinkSpeed.HUNDRED_MBPS,
                linkDuplex: ELinkDuplex.FULL,
              });
            }
          }}
        />
      </div>
      <div className="col-span-4">
        <span className="text-sm font-medium leading-6 text-gray-900">
          Speed
        </span>
      </div>
      <div className="col-span-8">
        {autoNegotiation ? (
          <FormInput
            data-testid="dialog-custom-edge-edit-link-speed-auto-input"
            id="link-speed-auto"
            name="linkSpeedAuto"
            value="Auto Negotiation"
            disabled
            readOnly
          />
        ) : (
          <FormSelect
            data-testid="dialog-custom-edge-edit-link-speed-select"
            options={linkSpeedOptions}
            value={linkSpeed ?? ELinkSpeed.AUTO}
            disabled={autoNegotiation}
            onChange={(e) =>
              onChangeEdgeData({ linkSpeed: e.target.value as ELinkSpeed })
            }
          />
        )}
      </div>
      <div className="col-span-4">
        <span className="text-sm font-medium leading-6 text-gray-900">
          Duplex
        </span>
      </div>
      <div className="col-span-8">
        {autoNegotiation ? (
          <FormInput
            data-testid="dialog-custom-edge-edit-link-duplex-auto-input"
            id="link-duplex-auto"
            name="linkDuplexAuto"
            value="Auto Negotiation"
            disabled
            readOnly
          />
        ) : (
          <FormSelect
            data-testid="dialog-custom-edge-edit-link-duplex-select"
            options={linkDuplexOptions}
            value={linkDuplex ?? ELinkDuplex.AUTO}
            disabled={autoNegotiation}
            onChange={(e) =>
              onChangeEdgeData({ linkDuplex: e.target.value as ELinkDuplex })
            }
          />
        )}
      </div>
      <div className="col-span-4">
        <span className="text-sm font-medium leading-6 text-gray-900">MDI</span>
      </div>
      <div className="col-span-8">
        <FormSelect
          data-testid="dialog-custom-edge-edit-link-mdi-select"
          options={linkMdiOptions}
          value={linkMdi ?? ELinkMdi.AUTO}
          onChange={(e) =>
            onChangeEdgeData({ linkMdi: e.target.value as ELinkMdi })
          }
        />
      </div>
    </div>
  );
}
